import React, { useState } from 'react';

/**
 * MemberAvatar - Displays a member's avatar (image or initials) with name on hover
 * @param {string} name - Member's name
 * @param {string} photo - Optional photo URL
 * @param {string} size - Size: 'xs', 'sm', 'md', 'lg' (default: 'sm')
 * @param {string} className - Additional CSS classes
 */
const MemberAvatar = ({ name, photo, size = 'sm', className = '' }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    const sizeClasses = {
        xs: 'w-6 h-6 text-xs',
        sm: 'w-8 h-8 text-sm',
        md: 'w-10 h-10 text-base',
        lg: 'w-12 h-12 text-lg'
    };

    const getInitials = (name) => {
        if (!name) return '?';
        const parts = name.trim().split(' ');
        if (parts.length === 1) {
            return parts[0].substring(0, 2).toUpperCase();
        }
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    };

    const getColorFromName = (name) => {
        if (!name) return 'bg-gray-500';
        const colors = [
            'bg-red-500',
            'bg-orange-500',
            'bg-yellow-500',
            'bg-green-500',
            'bg-teal-500',
            'bg-blue-500',
            'bg-indigo-500',
            'bg-purple-500',
            'bg-pink-500'
        ];
        const index = name.charCodeAt(0) % colors.length;
        return colors[index];
    };

    return (
        <div 
            className="relative inline-block"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
        >
            {photo ? (
                <img
                    src={photo}
                    alt={name}
                    className={`${sizeClasses[size]} rounded-full object-cover ${className}`}
                />
            ) : (
                <div
                    className={`${sizeClasses[size]} rounded-full flex items-center justify-center text-white font-semibold ${getColorFromName(name)} ${className}`}
                >
                    {getInitials(name)}
                </div>
            )}
            
            {/* Tooltip */}
            {showTooltip && (
                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded whitespace-nowrap z-50 pointer-events-none">
                    {name}
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
                        <div className="border-4 border-transparent border-t-gray-900"></div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MemberAvatar;

